import { ValidationErrors } from 'acscp/api/models/errorDetails';
import { Country } from 'acscp/api/models/country';
import React from 'react';
import { LocaleCode } from 'acscp/translations';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';
import { CallingCodeInput } from 'acscp/components/auth/callingCodeInput';
import { InputWithValidation } from 'acscp/components/common/validation/inputWithValidation';
import style from './telephoneNumberInput.module.scss';

const messages = defineMessages({
    placeholder: {
        id: 'web.components.auth.createAccountForm.localPartPlaceholder',
        defaultMessage: 'PHONE'
    },
});

interface TelephoneNumberInputOwnProps {
    callingCodeCountryInputName: string;
    telephoneNumberInputName: string;
    validationErrors: ValidationErrors | undefined;
    optionsAreLoading: boolean;
    countryOptions: Country[];
    namingLocale: LocaleCode;
    selectedCallingCodeCountry: Country | undefined;
    telephoneNumber: string;
    onChange: (callingCodeCountry: Country | undefined, telephoneNumber: string) => void;
}

type TelephoneNumberInputProps = InjectedIntlProps & TelephoneNumberInputOwnProps;

const TelephoneNumberInputPresentational: React.FC<TelephoneNumberInputProps> = props => {
    return (
        <div className={style.Container}>
            <CallingCodeInput
                inputName={props.callingCodeCountryInputName}
                inputContainerClassNames={style.CallingCode}
                validationErrors={props.validationErrors}
                optionsAreLoading={props.optionsAreLoading}
                options={props.countryOptions}
                value={props.selectedCallingCodeCountry}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                    const countryId = event.target.value;
                    const country = props.countryOptions.find(c => c.id === countryId);
                    props.onChange(country, props.telephoneNumber);
                }}
                countryNamesLocale={props.namingLocale}
            />
            <InputWithValidation
                name={props.telephoneNumberInputName}
                inputContainerClassNames={style.Number}
                id={props.telephoneNumberInputName}
                value={props.telephoneNumber}
                type="tel"
                maxLength={30}
                placeholder={props.intl.formatMessage(messages.placeholder)}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.onChange(props.selectedCallingCodeCountry, event.target.value);
                }}
                validationErrors={props.validationErrors}
            />
        </div>
    );
};

export const TelephoneNumberInput = injectIntl(TelephoneNumberInputPresentational);
